// extracted by mini-css-extract-plugin
export default {"detalle":"PopupSustitucion_detalle__eYv8d"};